import React from 'react';

const Preket = ({ data, referTo, select }) => {
  let total = [];
  let reMake = [];
  let array = [];
  let f = 1;
  //deep copy
  const newData = JSON.parse(JSON.stringify(data));
  console.log('newData', newData);
  newData.forEach((e, index) => {
    e.shortage = e.max_stock - e.current_stock;

    const a = JSON.parse(JSON.stringify(e));
    const idx = total.findIndex((x) => x.id?.upc === a.id?.upc);
    if (idx > -1) {
      total[idx].shortage += a.shortage;
      total[idx].current_stock += a.current_stock;
      total[idx].max_stock += a.max_stock;
    } else {
      total.push(a);
    }

    if (f === e.floor && index !== data.length - 1) {
      array.push(e);
    } else {
      if (index === data.length - 1) {
        array.push(e);
        reMake.push(array);
      } else {
        reMake.push(array);
        array = [];
        array.push(e);
        ++f;
      }
    }
  });

  if (select?.name) {
    return (
      <div id="pkToPrint">
        <div
          id="pkToPrint2"
          style={{
            pageBreakAfter: 'always',
          }}
        >
          <div
            style={{
              fontSize: total.length <= 25 ? '35px' : '15px',
              marginBottom: '5px',
              textAlign: 'center',
            }}
          >
            {select.name}
            {select.description ? `(${select.description})` : ''}
          </div>

          <div style={{ fontSize: '20x' }}>
            {/* Header Row */}
            <div
              style={{
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                textAlign: 'start',
                marginLeft: '20px',
                backgroundColor: '#f0f0f0',
                fontWeight: 'bold',
                borderBottom: '2px solid #ccc',
                marginBottom: '5px',
              }}
            >
              <div
                style={{
                  height: '40px',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '14px',
                }}
              >
                Image
              </div>
              <div>
                <div
                  style={{ width: total.length <= 17 ? '100px' : '120px', display: 'inline-block' }}
                >
                  UPC
                </div>
                <div style={{ width: '300px', display: 'inline-block' }}>Name</div>
                <div style={{ width: '60px', display: 'inline-block' }}>Short</div>
                <div style={{ width: '50px', display: 'inline-block' }}>Max</div>
                <div style={{ width: '60px', display: 'inline-block' }}>Stock</div>
              </div>
            </div>

            {/* Data Rows */}
            {total.length <= 17
              ? total.map((e, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        height: '60px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        textAlign: 'start',
                        marginLeft: '20px',
                      }}
                    >
                      <div
                        style={{
                          height: '60px',
                          width: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          style={{ maxHeight: '80%', maxWidth: '80%', marginRight: '14px' }}
                          alt="pdimg"
                          src={`${process.env.REACT_APP_SERVER_API}/pictures/${e.id?.productPictures[0]}/${referTo}`}
                        ></img>
                      </div>
                      <div>
                        <div style={{ width: '100px', display: 'inline-block' }}>{e.id.upc}</div>
                        <div style={{ width: '300px', display: 'inline-block' }}>
                          {e.id.name?.en}
                        </div>
                        <div style={{ width: '60px', display: 'inline-block' }}>{e.shortage}</div>
                        <div style={{ width: '50px', display: 'inline-block' }}>{e.max_stock}</div>
                        <div style={{ width: '60px', display: 'inline-block' }}>
                          {e.current_stock}
                        </div>
                      </div>
                    </div>
                  );
                })
              : total.map((e, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        height: total.length <= 25 ? '30px' : '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        textAlign: 'start',
                        marginLeft: '20px',
                        fontSize: '10px !important',
                        marginTop: e.id.name?.en?.length > 30 ? '5px' : '5px',
                        marginBottom: e.id.name?.en?.length > 30 ? '5px' : '5px',
                      }}
                    >
                      <div
                        style={{
                          height: total.length <= 25 ? '30px' : '15px',
                          width: total.length <= 25 ? '30px' : '15px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          style={{ maxHeight: '98%', maxWidth: '98%', marginRight: '14px' }}
                          alt="pdimg"
                          src={`${process.env.REACT_APP_SERVER_API}/pictures/${e.id?.productPictures[0]}/${referTo}`}
                        ></img>
                      </div>
                      <div className="d-flex">
                        <div style={{ width: '160px', display: 'inline-block' }}>{e.id.upc}</div>
                        <div style={{ width: '300px', display: 'inline-block' }}>
                          {e.id.name?.en}
                        </div>
                        <div style={{ width: '60px', display: 'inline-block' }}>{e.shortage}</div>
                        <div style={{ width: '50px', display: 'inline-block' }}>{e.max_stock}</div>
                        <div style={{ width: '60px', display: 'inline-block' }}>
                          {e.current_stock}
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
        <div
          id="pkToPrint3"
          style={
            {
              // paddingTop: '20px',
            }
          }
        >
          <div style={{ width: '90%', margin: 'auto' }}>
            {reMake.map((floor, i) => {
              return (
                <div
                  key={i}
                  style={{
                    background: 'lightblue',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {floor.map((slot) => {
                    return (
                      <div
                        style={{ height: '120px', paddingLeft: '1px', paddingRight: '1px' }}
                        key={slot.idx}
                      >
                        <div
                          style={{
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img
                            style={{ maxWidth: '80%', maxHeight: '80%' }}
                            alt="pdimg"
                            src={`${process.env.REACT_APP_SERVER_API}/pictures/${slot.id?.productPictures[0]}/${referTo}`}
                          ></img>
                        </div>
                        <div style={{ fontSize: '10px' }}> {slot.id?.upc}</div>
                        <div style={{ fontSize: '11px' }}> {`${slot.idx} (${slot.shortage})`}</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else return null;
};

export default Preket;
